execv2.tutorial.objects = {
    containerTutorial: document.getElementById("containerTutorial"),
    containerRequest: document.getElementById("containerRequest"),
    containerTutorialTitle: document.getElementById("containerTutorialTitle"),
    containerTutorialDesc: document.getElementById("containerTutorialDesc"),
    containerTutorialDate: document.getElementById("containerTutorialDate"),
    containerTutorialFeedbackButton: document.getElementById("containerTutorialFeedbackButton"),
    containerTutorialFeedbackMsg: document.getElementById("containerTutorialFeedbackMsg"),
    containerTutorialMenu: document.getElementById("containerTutorialMenu"),
    containerTutorialButton: document.getElementById("containerTutorialButton"),
    containerTutorialContents: document.getElementById("containerTutorialContents"),
    containerTutorialProceedToRequest: document.getElementById("containerTutorialProceedToRequest"),
    btnTutorialShow: document.querySelector("#containerTutorialMenu a"),
    btnCloseTutorial: document.getElementById("btnCloseTutorial"),
    btnTutorialLike: document.getElementById("btnTutorialLike"),
    btnTutorialDislike: document.getElementById("btnTutorialDislike"),
    chkDoNotShowTutorialMore: document.getElementById("chkDoNotShowTutorialMore"),
    spinner: document.getElementById("containerTutorial").querySelector(".spinner"),
    cookieBlockName: "service-tutorial-block",
    cookieFeedbackName: "service-tutorial-feedback"
}


//consulta no banco de dados o tutorial
execv2.tutorial.get = function () {


    //se não é um serviço, então não nem procurar tutorial
    if (execv2.objects.codServiceSafeEnc === "") {
        execv2.tutorial.close();
        return;
    }

    //tem um processo/servico ou url associado associado?
    if (execv2.tutorial.showProceedButton()) {
        bsml.show(execv2.tutorial.objects.containerTutorialProceedToRequest);
    } else {
        //não tem, esconde botão para prosseguir com solicitação
        h.remove(execv2.tutorial.objects.containerTutorialProceedToRequest);
    }

    //verifica se o usuário não bloqueou a visualização 
    if (execv2.tutorial.isBlocked()) execv2.tutorial.close();

    //é uma tela de tarefa, tutorial vem sem segundo plano
    if (execv2.objects.isTask) execv2.tutorial.close();
        

    //mesmo tendo bloqueado, carrega o tutorial, pois ele pode querer ver depois
    h.getJSON(
        execv2.services.urlTutorialGet,
        function (data) {
            if (data.success) {
                execv2.tutorial.objects.containerTutorialTitle.innerHTML = data.success.dst;
                execv2.tutorial.objects.containerTutorialDesc.innerHTML = data.success.ds;
                execv2.tutorial.objects.containerTutorialDate.innerHTML = data.success.dtc;
                execv2.tutorial.resizeImages();

                //não esta bloqueado mostra o tututorial
                if (!execv2.tutorial.isBlocked() && !execv2.objects.isTask) {
                    execv2.tutorial.show();
                }
                //mostra o menu de tutorial 
                bsml.show(execv2.tutorial.objects.containerTutorialMenu);
            } else {
                execv2.tutorial.close();
            }
        }
    );
}

execv2.tutorial.showProceedButton = function () {

    return execv2.objects.codFlow != "" || execv2.objects.urlToRedirect != "";

}

//redimensiona as imagens do conteudo do tutorial para serem responsivas
execv2.tutorial.resizeImages = function () {

    let imgs = execv2.tutorial.objects.containerTutorialDesc.querySelectorAll("img");
    
    h.forEach(imgs, function (i, img) {
        h.addClass(img, "img-fluid");
    });
}

//esconde o bloco do tuturial
execv2.tutorial.close = function () {
    if (execv2.objects.codFlow != "") {
       bsml.hide(execv2.tutorial.objects.containerTutorial);
       bsml.show(execv2.tutorial.objects.containerRequest);
       location.href = "#top";
    }

    if (execv2.objects.urlToRedirect != "") {
        bsml.toggleButtonSpinner(execv2.tutorial.objects.btnCloseTutorial, true);
        location.href = execv2.objects.urlToRedirect;
    }

}

//mostra o bloco do tuturial
execv2.tutorial.show = function () {

    bsml.show(execv2.tutorial.objects.containerTutorial);
    bsml.hide(execv2.tutorial.objects.containerRequest);
    location.href = "#top";
}

//registra em banco de dados que usuario  gostou do conteudo
execv2.tutorial.like = function () {

    h.callWebAPI(
        execv2.services.urlTutorialLike,
        "PUT",
        null,
        function (data) {
            if (data.success) {
                execv2.tutorial.feedbackRegisterCookie();
                execv2.tutorial.feedbackThankyou();
            }
        }
    );
}

//registra em banco de dados que usuario não gostou do conteudo
execv2.tutorial.dislike = function () {

    h.callWebAPI(
        execv2.services.urlTutorialDislike,
        "PUT",
        null,
        function (data) {
            if (data.success) {
                execv2.tutorial.feedbackRegisterCookie();
                execv2.tutorial.feedbackThankyou();
            }
        }
    );
}

//registra em cookie que o usuario votou em conteudo
execv2.tutorial.feedbackRegisterCookie = function () {
    var actualvalue = h.getCookie(execv2.tutorial.objects.cookieFeedbackName);

    if (actualvalue.indexOf(execv2.objects.codServiceSafeEnc) < 0) {
        let newvalue = `${actualvalue}|${execv2.objects.codServiceSafeEnc}`;
        h.setCookie(execv2.tutorial.objects.cookieFeedbackName, newvalue);
    }
}

//verifica se o usuário ja votou no conteudo
execv2.tutorial.checkFeedbackExists = function () {
    
    var actualvalue = h.getCookie(execv2.tutorial.objects.cookieFeedbackName);
    if (actualvalue.indexOf(execv2.objects.codServiceSafeEnc) >= 0)
        execv2.tutorial.feedbackThankyou();
}

//mostra mensagem de obrigado por ter votado no conteudo
execv2.tutorial.feedbackThankyou = function () {
    h.remove(containerTutorialFeedbackButton);
    bsml.show(containerTutorialFeedbackMsg);
}

//evento apos clicar no checkbox para bloquear ou desbloquear conteudo
execv2.tutorial.blockOrUnblock = function (e) {

    if (e.target.checked) { execv2.tutorial.block(); }
    else                  { execv2.tutorial.unblock();}
}

//verifica se o usuario bloqueou o conteudo no passado
execv2.tutorial.isBlocked = function () {
    let cookievalue = h.getCookie(execv2.tutorial.objects.cookieBlockName);
    
    return cookievalue.indexOf(execv2.objects.codServiceSafeEnc) >= 0;
}

//bloqueia um conteudo para não ser mais visto, adicionando chave no bookie
execv2.tutorial.block = function () {
    var actualvalue = h.getCookie(execv2.tutorial.objects.cookieBlockName) ;
    
    if (actualvalue.indexOf(execv2.objects.codServiceSafeEnc) < 0) {
        let newvalue = `${actualvalue}|${execv2.objects.codServiceSafeEnc}`;
        h.setCookie(execv2.tutorial.objects.cookieBlockName, newvalue);
    }
}

//desbloqueia um conteudo, apagando o registro do cookie
execv2.tutorial.unblock = function () {
    var actualvalue = h.getCookie(execv2.tutorial.objects.cookieBlockName) ;
    if (actualvalue.indexOf(execv2.objects.codServiceSafeEnc) >= 0) {
        
        let newvalue = actualvalue.replace(`|${execv2.objects.codServiceSafeEnc}`, "");
        h.setCookie(execv2.tutorial.objects.cookieBlockName, newvalue);
    }
}

//configura o padding inferior da area de conteudo  para a altura da barra de botões, para o conteudo não ficar escondido
execv2.tutorial.setContentVisibleArea = function () {
    execv2.tutorial.objects.containerTutorialContents.style.paddingBottom =
            (execv2.tutorial.objects.containerTutorialButton.clientHeight)*2 + "px";

}


execv2.tutorial.setup = function () {

    //configura os event handlers dos botões
    h.addEventListener(execv2.tutorial.objects.btnCloseTutorial, "click", execv2.tutorial.close);
    h.addEventListener(execv2.tutorial.objects.btnTutorialLike, "click", execv2.tutorial.like);
    h.addEventListener(execv2.tutorial.objects.btnTutorialDislike, "click", execv2.tutorial.dislike);
    h.addEventListener(execv2.tutorial.objects.chkDoNotShowTutorialMore, "click", execv2.tutorial.blockOrUnblock);
    h.addEventListener(execv2.tutorial.objects.btnTutorialShow, "click", execv2.tutorial.show);

    //consulta o cookie para marcar ou nào checkbox
    execv2.tutorial.objects.chkDoNotShowTutorialMore.checked = execv2.tutorial.isBlocked();
    //verifica se usuario ja votou no tutorial
    execv2.tutorial.checkFeedbackExists();
    //reconfigura o tamanho da area visivel
    execv2.tutorial.setContentVisibleArea();

}

execv2.tutorial.init = function () {
    //consulta o tututorial
    execv2.tutorial.get();
}

execv2.tutorial.setup();
execv2.tutorial.init();

